import React from "react";
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  CircularProgress,
  Button,
  IconButton,
  Checkbox,
  TablePagination,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useEffect } from "react";
import {
  getTransactionDetails,
  getTransactionRelation,
  listAccountTransactionDetails,
  listAccountTransactionExtraDetails,
  listTransactionRelation,
} from "../../graphql/queries";
import { API, graphqlOperation } from "aws-amplify";
import { useState } from "react";
import { ArrowBackIosNewTwoTone } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteLinkToPayment from "./DeleteLinkToPayment";
import { MoneyFormat } from "../../library/MoneyFormat";
import { useThemes } from "../Theme/theme";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  // p: 4,
  outline: "none",
};

const headCell = [
  {
    id: "Receipt No:",
    label: "Receipt No:",
    minWidth: 140,
  },
  {
    id: "Receipt Date",
    label: "Receipt Date",
    minWidth: 140,
  },
  {
    id: "Receipt Amount",
    label: "Receipt Amount",
    minWidth: 140,
  },
  {
    id: "Balance in Receipt Voucher",
    label: "Balance in Receipt Voucher",
    minWidth: 140,
  },
  {
    id: "Linked Amount",
    label: "Linked Amount",
    minWidth: 140,
  },
  {
    id: "Current Balance",
    label: "Current Balance",
    minWidth: 140,
  },
  {
    id: "Action",
    label: "Action",
    minWidth: 140,
  },
];

function createData(
  no,
  date,
  amount,
  balanceinvocher,
  linkedAmount,
  currentBalance
) {
  return { no, date, amount, balanceinvocher, linkedAmount, currentBalance };
}

const rows = [createData("P1231/22-23", "16-05-2022", 10000, 10000, 10000, 0)];

const LinktoReceipt = ({
  open,
  setOpen,
  accountID,
  setTransArr,
  entryData,
  setWarningText,
  setWarningSnakbar,
  setLinkedData,
  setLinkedDetails,
  invoiceAmount,
  invoiceDetails,
}) => {
  const { theme } = useThemes()

  const [rows, setRows] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [listAccountTransDetails, setListAccountTransDetails] = useState([]);
  const [selected, setSelected] = useState([]);
  const [usedAmount, setUsedAmount] = useState("");
  const [listTransRelatedData, setTransRealatedData] = useState([]);
  const [unUsedAmount, setUnUsedAmount] = useState("");
  const [allLinkedAmount, setAllLinkedAmount] = useState("");
  const [deleteEvent, setDeleteEvent] = useState(false);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [voucherLinkedAmount, setVoucherLinkedAmount] = useState("");
  const [deleteLinkToPaymentModal, setDeletLinkToPaymentModal] =
    useState(false);
  const [transId, setTransId] = useState("");
  const [objectID, setObjectID] = useState("");
  const [objectAttribute, setObjectAttribute] = useState("");
  const [colIndex, setColIndex] = useState("");
  const [indexOfLinkAmount, setIndexOfLinkAmount] = useState(0)
  const [state, setState] = useState({
    linkedAmount: "",
    balanceInVoucher: "",
  });
  const handleInputChange = (e, id, ind) => {
    rows.map((ele) => {
      if (ele.TransactionID === id) {
        setState((prev) => ({
          ...prev,
          linkedAmount: e.target.value,
        }));
        ele.LinkedAmount = e.target.value;
      }
    });
    setColIndex(ind);
    let totLinkedAmount = 0;
    rows.map((ele) => {
      totLinkedAmount += Number(ele.LinkedAmount);
      ele.UsedAmount = totLinkedAmount;
    });
    setLinkedDetails(rows);
    setUsedAmount(totLinkedAmount);
    let UnUsedAmount = 0;
    if (entryData.getInvoiceMaster != undefined) {
      UnUsedAmount =
        Number(entryData.getInvoiceMaster.InvoiceAmount) -
        Number(totLinkedAmount);
      setUnUsedAmount(UnUsedAmount);
    } else {
      UnUsedAmount = Number(invoiceAmount) - Number(totLinkedAmount);
      setUnUsedAmount(UnUsedAmount);
    }
  };
  useEffect(() => {
    if (colIndex !== "") {
      handleClick(page * rowsPerPage + (colIndex + 1));
    }
  }, [colIndex]);
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      let usedAmt = 0;
      rows.map((ele) => {
        if (ele.Linked !== true) ele.LinkedAmount = "";
        usedAmt += Number(ele.LinkedAmount);
        ele.UsedAmount = usedAmt;
      });
      setLinkedDetails(rows);
      setUsedAmount(usedAmt);
      setSelected([]);
      setState((prev) => ({
        ...prev,
        linkedAmount: "",
      }));
      setOpen(false);
    }
  };

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  const handleClick = (name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };
  const saveLinkTranSaction = () => {
    let arr = [];

    rows?.map((ele, ind) => {
      selected.map((subele) => {
        if (ind + 1 === subele) {
          arr.push(ele);
        }
      });
    });
    let filterArr = [];
    rows.filter((ele) => {
      if (ele.Linked != true) {
        filterArr.push(ele);
      }
    });
    if (filterArr.length > 0) {
      if (selected.length == 0 && indexOfLinkAmount == 0) {
        setWarningText("Please select the entry!");
        setWarningSnakbar(true);
      } else {
        let warningMsg = "";
        let isValid = false;
        arr.filter((ele) => {
          if (
            ele.BalanceInVoucher < 0 &&
            entryData?.getInvoiceMaster != undefined &&
            entryData?.getInvoiceMaster.InvoiceAmount < usedAmount
          ) {
            // setWarningText(
            //   "Insufficient Balance in Payment Voucher! & Used Amount should be less than Invoice Amount!"
            // );
            // setWarningSnakbar(true);
            // setOpen(true);
            warningMsg =
              "Insufficient Balance in Payment Voucher! & Used Amount should be less than Invoice Amount!";
            isValid = true;
          } else if (ele.BalanceInVoucher < 0 && ele.LinkedAmount == 0) {
            // setWarningText(
            //   "Insufficient Balance in Receipt Voucher! & Linked Amount is Required"
            // );
            // setWarningSnakbar(true);
            // setOpen(true);
            warningMsg =
              "Insufficient Balance in Receipt Voucher! & Linked Amount is Required";
            isValid = true;
          } else if (
            entryData?.getInvoiceMaster != undefined &&
            entryData?.getInvoiceMaster.InvoiceAmount < usedAmount || invoiceAmount < usedAmount
          ) {
            // setWarningText("Used Amount should be less than Invoice Amount!");
            // setWarningSnakbar(true);
            // setOpen(true);
            warningMsg = "Used Amount should be less than Invoice Amount!";
            isValid = true;
          } else if (ele.BalanceInVoucher < 0) {
            // setWarningText(
            //   "Failed to Link.Insufficient Balance in Receipt Voucher!"
            // );
            // setWarningSnakbar(true);
            // setOpen(true);
            warningMsg =
              "Failed to Link.Insufficient Balance in Receipt Voucher!";
            isValid = true;
          } else if (ele.LinkedAmount == 0) {
            // setWarningText("Linked Amount is Requird");
            // setWarningSnakbar(true);
            // setOpen(true);
            warningMsg = "Linked Amount is Requird";
            isValid = true;
          } else if (
            Number(ele.PayAmount - usedAmount) <
            Number(indexOfLinkAmount)
          ) {
            warningMsg = "Linked Amount should be less than Balance in Voucher";
            isValid = true;
          } else {
          }
        });
        if (isValid == true) {
          setWarningText(warningMsg);
          setWarningSnakbar(true);
          setOpen(true);
        } else {
          setTransArr(arr);
          setWarningSnakbar(false);
          setOpen(false);
        }
      }
    }
  };
  async function getTransactionData() {
    try {
      setBackdropOpen(true);
      let arr = [];
      const res = await API.graphql(
        graphqlOperation(listAccountTransactionExtraDetails, {
          TransactionTypeCD1: "CashReceipt",
          TransactionTypeCD2: "BankReceipt",
          AccountID: accountID,
        })
      );
      let uniqueIds = [];
      const transactionDetails =
        res.data.listAccountTransactionExtraDetails.filter((element) => {
          const isDuplicate = uniqueIds.includes(element.TransactionID);

          if (!isDuplicate) {
            uniqueIds.push(element.TransactionID);

            return true;
          }

          return false;
        });
      setListAccountTransDetails(transactionDetails);

      transactionDetails.map((ele) => {
        if (ele.CreditAmount == 0) {
          ele.PayAmount = ele.DebitAmount;
        } else {
          ele.PayAmount = ele.CreditAmount;
        }
        let from = new Date(Number(ele.EntryDate) * 1000);
        let fromyy = from.getFullYear();
        let frommm = from.getMonth() + 1;
        let fromdd = from.getDate();

        if (fromdd < 10) fromdd = "0" + fromdd;
        if (frommm < 10) frommm = "0" + frommm;

        ele.entryDate = fromyy + "-" + frommm + "-" + fromdd;
        ele.Checked = "";
        arr.push({
          ReceiptNumber: ele.VoucherNumber,
          entryDate: ele.entryDate,
          PayAmount: ele.PayAmount,
          BalanceInVoucher: (
            Number(ele.PayAmount).toFixed(2) -
            Number(voucherLinkedAmount).toFixed(2)
          ).toFixed(2),
          AccountBalance: ele.AccountBalance,
          TransactionTypeCD: ele.TransactionTypeCD,
          LinkedAmount: state.linkedAmount,
          TransactionID: ele.TransactionID,
          CurrentBalance: (
            Number(ele.PayAmount).toFixed(2) -
            Number(voucherLinkedAmount).toFixed(2) -
            Number(state.linkedAmount).toFixed(2)
          ).toFixed(2),
        });
      });

      setRows(arr);
      setBackdropOpen(false);
    } catch (error) {
      console.log("error", error);
    }
  }
  async function listTransactionRelatedData() {
    try {
      setBackdropOpen(true);
      let totLinkedAmount = 0;
      let linkedPayments = [];
      const res = await API.graphql(graphqlOperation(listTransactionRelation));
      setTransRealatedData(res.data.listTransactionRelation);

      if (res.data.listTransactionRelation != null) {
        let AllLinkedAmountTotal = 0;
        res.data.listTransactionRelation.map((ele) => {
          if (ele.TransactionTypeCD == "SalesInvoice") {
            AllLinkedAmountTotal += Number(ele.LinkedAmount);
            rows.map((subele) => {
              if (ele.TransactionID == subele.TransactionID) {
                linkedPayments.push(subele);
                subele.Linked = true;
                subele.LinkedAmount = ele.LinkedAmount;
                subele.IsDirect = ele.IsDirect;
                subele.ObjectID = ele.ObjectID;
                subele.ObjectAttribute =
                  entryData?.getInvoiceMaster?.InvoiceNumber;
              }
            });
          }
        });
        let totPaymentLinkedAmount = 0;
        res.data.listTransactionRelation.map((ele) => {
          rows.map((subele) => {
            if (subele.ReceiptNumber === ele.ObjectAttribute) {
              totPaymentLinkedAmount += ele.LinkedAmount;
              // subele.BalanceInVoucher=Number(subele.PayAmount).toFixed(2)-Number(totPaymentLinkedAmount).toFixed(2)
            }
          });
        });
        setVoucherLinkedAmount(totPaymentLinkedAmount);
        setLinkedData(linkedPayments);

        rows.map((subele) => {
          totLinkedAmount += Number(subele.LinkedAmount);
          subele.UsedAmount = totLinkedAmount;
        });
        setLinkedDetails(rows);
        setAllLinkedAmount(AllLinkedAmountTotal);
        setUsedAmount(totLinkedAmount);
        setLinkedDetails(rows);
        let UnUsedAmount = 0;
        if (entryData.getInvoiceMaster != undefined) {
          UnUsedAmount =
            Number(entryData?.getInvoiceMaster?.InvoiceAmount) -
            Number(totLinkedAmount);
          setUnUsedAmount(UnUsedAmount);
        } else {
          UnUsedAmount = Number(invoiceAmount) - Number(totLinkedAmount);
          setUnUsedAmount(UnUsedAmount);
        }
      }
      setBackdropOpen(false);
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    listTransactionRelatedData();
  }, [rows, open]);
  useEffect(() => {
    getTransactionData();
  }, [accountID, deleteEvent]);
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      // disableBackdropClick
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "10px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  lineHeight: "1.5"
                }}
              >
                Link to Receipts
                <IconButton aria-label="delete" onClick={handleClose}>
                  <CloseIcon sx={{ color: "#fff", fontSize: "20px" }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              backgroundColor: "white",
              padding: "15px",
              height: { xs: "400px", sm: "auto" },
              overflowY: { xs: "scroll", sm: "hidden" },
              ".MuiTableCell-root": {
                padding: "10px 10px",
                fontSize: "13px",
              },
            }}
          >
            <Box sx={{ display: "flex" }}>
              <Box sx={{ flex: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <Typography
                    sx={{
                      flex: 0.5,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#888888",
                    }}
                  >
                    Invoice No
                  </Typography>
                  <Typography
                    sx={{
                      flex: 0.5,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#888888",
                    }}
                  >
                    :{" "}
                    {entryData.length !== 0
                      ? entryData?.getInvoiceMaster?.InvoiceNumber
                      : invoiceDetails.invoiceNumber}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <Typography
                    sx={{
                      flex: 0.5,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#888888",
                    }}
                  >
                    Invoice Amount
                  </Typography>
                  <Typography
                    sx={{
                      flex: 0.5,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#888888",
                    }}
                  >
                    : ₹{" "}
                    {entryData.length !== 0
                      ? MoneyFormat(Number(entryData?.getInvoiceMaster?.InvoiceAmount).toFixed(2), "en-IN")
                      : invoiceAmount.toFixed(2)}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ flex: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <Typography
                    sx={{
                      flex: 0.5,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#888888",
                    }}
                  >
                    Used Amount
                  </Typography>
                  <Typography
                    sx={{
                      flex: 0.5,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#888888",
                    }}
                  >
                    : ₹ {MoneyFormat(Number(usedAmount).toFixed(2), "en-IN")}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <Typography
                    sx={{
                      flex: 0.5,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#888888",
                    }}
                  >
                    Unused Amount
                  </Typography>
                  <Typography
                    sx={{
                      flex: 0.5,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#888888",
                    }}
                  >
                    : ₹{" "}
                    {entryData.length == 0 && invoiceAmount == 0
                      ? "0.00"
                      : MoneyFormat(Number(unUsedAmount).toFixed(2), "en-IN")}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <TableContainer
              component={Paper}
              sx={{
                maxHeight: "400px",
              }}
            >
              <Table sx={{}} aria-label="simple table">
                <TableHead sx={{ color: theme.palette.secondary.main }}>
                  <TableRow>
                    <TableCell
                      padding="checkbox"
                      sx={{
                        ".css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root": {
                          padding: "5px",
                        },
                        backgroundColor: theme.palette.secondary.main,
                      }}
                    >
                      {/* <Checkbox
                                                color="primary"
                                                size='small'
                                            /> */}
                    </TableCell>
                    {headCell.map((column, ind) => {
                      return (
                        <TableCell
                          key={ind}
                          sx={{
                            backgroundColor: theme.palette.secondary.main,
                            color: "#FFF",
                            lineHeight: "1em",
                            ".css-1r01dqu .MuiTableCell-root": {
                              fontSize: "13px",
                              minWidth: "200px"
                            }
                          }}
                        >
                          {column.label}{" "}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stableSort(
                    rows.sort(function (a) {
                      if (a.Linked == true) {
                        return -1;
                      } else {
                        return 1;
                      }
                    }),
                    getComparator(order, orderBy)
                  )
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, ind) => {
                      const isItemSelected = isSelected(
                        page * rowsPerPage + (ind + 1)
                      );
                      const labelId = `enhanced-table-checkbox-${ind}`;
                      return (
                        <TableRow
                          key={ind}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                            backgroundColor:
                              row.Linked == true ? "#a3a0a01a" : "#fff",
                          }}
                        >
                          <TableCell
                            padding="checkbox"
                            sx={{
                              ".css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root":
                              {
                                padding: "5px",
                              },
                            }}
                          >
                            {row.Linked !== true && (
                              <Checkbox
                                value={page * rowsPerPage + (ind + 1)}
                                color="primary"
                                onClick={(event) => {
                                  handleClick(page * rowsPerPage + (ind + 1));
                                  row.Checked = page * rowsPerPage + (ind + 1);
                                }}
                                checked={isItemSelected || row.LinkedAmount}
                                inputProps={{
                                  "aria-labelledby": labelId,
                                }}
                                size="small"
                              />
                            )}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: row.Linked == true ? "#20e0cf" : "#396afc",
                              minWidth: "100px",
                            }}
                            align="left"
                          >
                            {row.ReceiptNumber}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: row.Linked == true ? "#20e0cf" : "#396afc",
                              minWidth: "100px",
                            }}
                            align="left"
                          >
                            {row.entryDate}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: row.Linked == true ? "#20e0cf" : "#396afc",
                              minWidth: "100px",
                            }}
                            align="left"
                          >
                            ₹ {MoneyFormat(Number(row.PayAmount).toFixed(2), "en-IN")}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: row.Linked == true ? "#20e0cf" : "#396afc",
                              minWidth: "100px",
                            }}
                            align="left"
                          >
                            ₹{" "}
                            {MoneyFormat((
                              Number(row.PayAmount).toFixed(2) -
                              Number(usedAmount).toFixed(2)
                              // Number(voucherLinkedAmount).toFixed(2)
                            ).toFixed(2), "en-IN")}
                          </TableCell>
                          <TableCell>
                            {row.Linked === true ? (
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  minWidth: "150px",
                                  color:
                                    row.Linked == true ? "#20e0cf" : "#396afc",
                                }}
                              >
                                ₹ {MoneyFormat(Number(row.LinkedAmount).toFixed(2), "en-IN")}
                              </Typography>
                            ) : (
                              <TextField
                                align="left"
                                sx={{
                                  minWidth: "150px",
                                  maxHeight: "0.1px",
                                  mb: 5,
                                  ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                  {
                                    color:
                                      row.Linked == true
                                        ? "#20e0cf"
                                        : "#396afc",
                                    height: "1.2em",
                                  },
                                }}
                                type="number"
                                placeholder="₹"
                                size="small"
                                value={row.LinkedAmount}
                                onChange={(e) => {
                                  setIndexOfLinkAmount(e.target.value)
                                  handleInputChange(e, row.TransactionID, ind)
                                }}
                                InputProps={{
                                  inputProps: {
                                    min: 0,
                                  },
                                }}
                                onKeyPress={(event) => {
                                  if (
                                    event?.key === "-" ||
                                    event?.key === "+"
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                              ></TextField>
                            )}
                          </TableCell>
                          {/* <TableCell align="left">₹ {row.linkedAmount}</TableCell> */}
                          <TableCell
                            sx={{
                              color: row.Linked == true ? "#20e0cf" : "#396afc",
                              minWidth: "100px",
                            }}
                            align="left"
                          >
                            ₹{" "}
                            {MoneyFormat((
                              Number(row.PayAmount).toFixed(2) -
                              Number(usedAmount).toFixed(2)
                              // Number(voucherLinkedAmount).toFixed(2) -
                              // Number(row.LinkedAmount).toFixed(2)
                            ).toFixed(2), "en-IN")}
                          </TableCell>
                          <TableCell align="left" sx={{ minWidth: "100px" }}>
                            <IconButton
                              aria-label="delete"
                              onClick={() => {
                                if (row.IsDirect !== 1) {
                                  setDeletLinkToPaymentModal(true);
                                  setTransId(row.TransactionID);
                                  setObjectID(row.ObjectID);
                                  setObjectAttribute(row.ObjectAttribute);
                                }
                              }}
                              disabled={
                                row.Linked !== true || row.IsDirect == 1
                                  ? true
                                  : false
                              }
                              sx={{
                                margin: "0px 2px",
                                padding: "5px",
                                backgroundColor: "#fff",
                              }}
                            >
                              <DeleteIcon
                                sx={{
                                  fontSize: "15px",
                                  color:
                                    row.Linked !== true || row.IsDirect == 1
                                      ? "#c9c9c973"
                                      : "#eb6a6a",
                                }}
                              />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <TablePagination
            sx={{
              scrollbarWidth: "thin",
              "&::-webkit-scrollbar": {
                // width: '0.4em',
                height: "0.2em",
              },
              "&::-webkit-scrollbar-track": {
                background: `${theme.palette.primary.main}47`,
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "primary.main",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: `${theme.palette.primary.main}47`,
              },
            }}
            rowsPerPageOptions={[10, 20, 50]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />

          <Box
            sx={{
              // padding : "15px",
              // width:'100%',
              display: "flex",
              justifyContent: "space-between",
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <Button
              onClick={handleClose}
              variant="outlined"
              sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
            >
              Cancel
            </Button>
            <Button
              onClick={saveLinkTranSaction}
              variant="contained"
              sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
            >
              LINK
            </Button>
          </Box>
          <DeleteLinkToPayment
            open={deleteLinkToPaymentModal}
            setOpen={setDeletLinkToPaymentModal}
            rows={rows}
            setRows={setRows}
            setDeleteEvent={setDeleteEvent}
            ObjectAttribute={objectAttribute}
            transId={transId}
            objectID={objectID}
          ></DeleteLinkToPayment>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={backdropOpen}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </Box>
      </Fade>
    </Modal>
  );
};

export default LinktoReceipt;
